import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import EventDetail from '@/components/EventDetail'
import CreateEvent from '@/components/CreateEvent'

Vue.use(Router)
Vue.use(Meta)

var serviceSite = 'http://futsal.mystrikingly.com'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter(){
        window.location = serviceSite
      }
    },
    {
      path: '/events/create',
      name: 'create-event',
      component: CreateEvent
    },
    {
      path: '/events/:event',
      name: 'event-detail',
      component: EventDetail
    },
    {
      path: '/_events/:event',
      redirect: '/events/:event'
    },
    {
      path: '*',
      beforeEnter(){
        window.location = serviceSite
      }
    },
  ]
})
